import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("steck_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const listReports = async (params = {}) => {
  const { data } = await api.get("/reports", { params });
  return data;
};

export const getReport = async (slug) => {
  const { data } = await api.get(`/reports/${slug}`);
  return data;
};

export const getInsightSeries = async () => {
  const { data } = await api.get("/insight-series");
  return data.series;
};

export const login = async (username, password) => {
  const { data } = await api.post("/auth/login", { username, password });
  localStorage.setItem("steck_admin_token", data.token);
  localStorage.setItem("steck_admin_user", data.username);
  return data;
};

export const logout = () => {
  localStorage.removeItem("steck_admin_token");
  localStorage.removeItem("steck_admin_user");
};

export const currentUser = () => localStorage.getItem("steck_admin_user");

export const adminListReports = async () => {
  const { data } = await api.get("/admin/reports");
  return data;
};

export const adminGetReport = async (id) => {
  const { data } = await api.get(`/admin/reports/${id}`);
  return data;
};

export const adminCreateReport = async (payload) => {
  const { data } = await api.post("/admin/reports", payload);
  return data;
};

export const adminUpdateReport = async (id, payload) => {
  const { data } = await api.put(`/admin/reports/${id}`, payload);
  return data;
};

export const adminDeleteReport = async (id) => {
  const { data } = await api.delete(`/admin/reports/${id}`);
  return data;
};

export const adminRegenerate = async (id) => {
  const { data } = await api.post(`/admin/reports/${id}/regenerate`);
  return data;
};

export const submitInquiry = async (payload) => {
  const { data } = await api.post("/inquiries", payload);
  return data;
};

export const adminListInquiries = async () => {
  const { data } = await api.get("/admin/inquiries");
  return data;
};

export const adminUpdateInquiryStatus = async (id, status) => {
  const { data } = await api.put(`/admin/inquiries/${id}/status`, { status });
  return data;
};

export const adminDeleteInquiry = async (id) => {
  const { data } = await api.delete(`/admin/inquiries/${id}`);
  return data;
};

export default api;
